var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ui-clipboard-input", {
        attrs: {
          disabled: _vm.isFetching || _vm.link.length === 0,
          hint: "Link copied to clipboard",
          label: "Live stream link",
        },
        model: {
          value: _vm.link,
          callback: function ($$v) {
            _vm.link = $$v
          },
          expression: "link",
        },
      }),
      _vm._v(" "),
      _c(
        "ui-dialog-footer",
        [
          _c("ui-button", {
            attrs: {
              disabled: _vm.isFetching || _vm.link.length > 0,
              primary: "",
              text: "Generate link",
              tooltip: "Generate password protected link",
            },
            on: { click: _vm.fetchShareStreamLink },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }